import { wlus } from './initial/flow';
import { wlusmonthly } from './monthly/flow';
import { wlusOral } from './oralDrops/flow';
import { wlusMonthlyOral } from './oralDropsMonthly/flow';
import {
  wl,
  wlus_032025,
  wlus_2024,
  wlus_archived
} from './initial/archived/flow';
import {
  wlusmonthly_2024,
  wlusmonthly_2025,
  wlusmonthly_archive
} from './monthly/archived/flow';
import { wlusOral_2024 } from './oralDrops/archived/flow';
import { wlusMonthlyOral_2024 } from './oralDropsMonthly/archived/flow';
import { wlusBranded } from './standard/flow';
import { wlusFollowupBranded } from './standardFollowup/flow';
import { SlendidWeightlossFlows } from './Slendid/flows';
import { wlusAltOnly } from './AlternativeOnlyInitial/flow';

const weightlossFlows = {
  wlus,
  wlus_archived,
  wlusmonthly,
  wlusmonthly_archive,
  wlusOral,
  wlusMonthlyOral,
  wl,
  wlus_2024,
  wlus_032025,
  wlusmonthly_2024,
  wlusmonthly_2025,
  wlusOral_2024,
  wlusMonthlyOral_2024,
  wlusBranded,
  wlusFollowupBranded,
  ...SlendidWeightlossFlows,
  wlusAltOnly
};

export default weightlossFlows;
